import Box from '@mui/material/Box';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { SxProps } from '@mui/material';
import ActionOptionLink from '../../../components/button';

const spacing = 20;

const PageWrapper = ({
  logout,
  showLogout = true,
  children,
  pageSx = {},
  containerSx = {},
  logoutSx = {},
}: {
  logout?: () => Promise<void>;
  showLogout?: boolean;
  pageSx?: SxProps;
  containerSx?: SxProps;
  logoutSx?: SxProps;
  children?: ReactJSXElement | string | void;
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        overflow: 'auto',
        backgroundColor: 'rgb(253, 249, 244)',
        ...pageSx,
      }}
    >
      <Box
        sx={{
          maxWidth: '500px',
          margin: '0px auto',
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          '>*': {
            marginTop: `${spacing}px`,
          },
          ...containerSx,
        }}
      >
        <>
          {children ? children : null}
          {showLogout && (
            <ActionOptionLink
              title="Logged in into wrong account?"
              buttonText="Logout"
              action={logout}
              color="#838383"
              sx={{
                marginTop: 'auto',
                flex: 0,
                padding: `${spacing}px`,
                ...logoutSx,
              }}
            />
          )}
        </>
      </Box>
    </Box>
  );
};

export default PageWrapper;
